import React from "react";
import styled, { css } from "styled-components";
import _ from "lodash";

import { PendingCustomerStatus as PendingCustomerStatusEnum } from "src/core/pending-customers/api/pendingCustomer.api";

interface IProps {
  status?: PendingCustomerStatusEnum;
}

interface IStatusWrapper {
  status?: string;
}

const StatusWrapper = styled("span")<IStatusWrapper>`
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  text-transform: capitalize;
  ${({ status }) => StatusCss(status)};
`;

const DefaultCss = css`
  color: inherit;
`;

const PendingCss = css`
color: ${({ theme }) => theme.colors.warn};
`;

const OnboardedCss = css`
color: ${({ theme }) => theme.colors.success};
`;

const RejectedCss = css`
  color: ${({ theme }) => theme.colors.error};
`;

// Gives the status the appropriate colour
const StatusCss = (status?: string) => {
  switch (status) {
    case PendingCustomerStatusEnum.Pending:
      return PendingCss;

    case PendingCustomerStatusEnum.Onboarded:
      return OnboardedCss;

    case PendingCustomerStatusEnum.Rejected:
      return RejectedCss;

    default:
      return DefaultCss;
  }
};

/**
 * Gets the pending customer status
 */
const PendingCustomerStatus = ({ status }: IProps) => {
  // Only return the status if one is given
  if (status) {
    return (
      <StatusWrapper status={status}>
        {_.capitalize(status)}
      </StatusWrapper>
    );
  }

  return (
    <StatusWrapper>
      -
    </StatusWrapper>
  );
};

export default PendingCustomerStatus;
